import { useState, useEffect } from 'react'
import api from 'utils/api'
import map from 'lodash/fp/map'
import getOr from 'lodash/fp/getOr'
import remove from 'lodash/fp/remove'

export default () => {
  const [chores, setChores] = useState([])
  const [kids, setKids] = useState([])
  const [kidOptions, setKidOptions] = useState([])
  const [error, setError] = useState(false)
  const [fetching, setFetching] = useState(false)

  useEffect(() => {
    setFetching(true)
    api(`/parents/chores`)
      .then((response) => {
        setFetching(false)
        setChores(getOr([], 'data.chores', response))
      })
      .catch(() => {
        setFetching(false)
        setError(true)
      })
  }, [])

  useEffect(() => {
    setFetching(true)
    api(`/parents/kids`)
      .then((response) => {
        setFetching(false)
        setKids(getOr([], 'data.kids', response))
        setKidOptions(kidsToOptions(getOr([], 'data.kids', response)))
      })
      .catch(() => {
        setFetching(false)
        setError(true)
      })
  }, [])

  const addChore = ({ name, repeat, price, kidId }) => {
    console.log(name, repeat, price, kidId)
  }

  const editChore = ({ id, name, repeat, price, kidId }) => {
    console.log(id, name, repeat, price, kidId)
  }

  const removeChore = ({ id }) => {
    setFetching(true)
    api
      .delete(`/parents/chores/${id}`)
      .then(() => {
        setFetching(false)
        setChores(remove((chore) => chore.id === id, chores))
      })
      .catch(() => {
        setFetching(false)
        setError(true)
      })
  }

  return {
    chores,
    kids,
    options: kidOptions,
    error,
    fetching,
    addChore,
    editChore,
    removeChore,
  }
}

const kidsToOptions = map((kid) => ({ label: kid.name, value: kid.id }))
